export default __webpack_public_path__ + "static/media/service.01d29800.svg";